// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@6.7.3_webpack@5.70.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@6.7.3_webpack@5.70.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yqashDXMeQDE5iIoEL7b {\n   font-weight: 600;\n}\n", "",{"version":3,"sources":["webpack://./Shared/prosemirror/tiptap/extensions/mentions/mentions.module.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;AACnB","sourcesContent":[".mention {\n   font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mention": "yqashDXMeQDE5iIoEL7b"
};
export default ___CSS_LOADER_EXPORT___;
